module.exports = __webpack_public_path__ + "static/img/bg4.055472d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg4.png
// module id = pKkh
// module chunks = 1